import { useTosterStore } from './store.ts';
import { Tost } from './types.ts';

export const TOST_CLOSE_DELAY = 5000;

/**
 * Displays a toast notification and automatically removes it after a delay.
 *
 * @param input - The toast object containing the details of the notification.
 *
 * @example
 * ```typescript
 * import { showTost } from '@/components/core/TosterCenter/tools';
 * import { Tost } from '@/components/core/TosterCenter/types';
 *
 * const myTost: Tost = {
 *   id: 'unique-id',
 *   title: 'This is a toast title!', // Optional
 *   description: 'This is a toast description', // Optional
 *   closeDelay: 3000, // Optional: Custom delay in milliseconds
 *   icon: MyIconComponent, // Optional: Custom icon component
 *   to: { name: 'InviteVillage' }, // Optional: navigate to named route on tap/click
 * };
 *
 * showTost(myTost);
 *
 * const myTostWithCustomComponent: Tost = {
 *   id: 'unique-id',
 *   closeDelay: 3000, // Optional: Custom delay in milliseconds
 *   component: MyCustomComponent, // Optional: Custom vue component
 * };
 *
 * showTost(myTostWithCustomComponent);
 * ```
 */
export const showTost = (input: Tost) => {
  const { addTost, removeTost } = useTosterStore();

  addTost(input);

  setTimeout(() => {
    removeTost(input.id);
  }, input.closeDelay || TOST_CLOSE_DELAY);
};
